module.exports = __webpack_public_path__ + "assets/a7f6da4729858fa32882ce04870420ec.jpg";